import { useEffect, useState } from "react";
import { ActivityNewsWidgetStyled } from "./styled";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATH } from "utils/constants/routePath";
import { userService } from "apiServices";
import { useTranslation } from "react-i18next";
import { Buttons, Cards } from "components";

const ActivityNewsWidget = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation(["home"]);

  const [_data, _setData] = useState();

  useEffect(() => {
    _fetchData();
  }, []);

  const _fetchData = async () => {
    let resArr = await Promise.all([
      userService.GET_ACTIVITY_LIST(`?is_active=true&pagination=false`),
      userService.GET_ACTIVITY_FORM_LIST(`?is_active=true&pagination=false`),
      userService.GET_NEW_LIST(`?is_active=true`),
    ]);
    if (resArr) {
      const activityReduce = resArr[0].data.docs.reduce(
        (result, data) => {
          if (data.is_pin) {
            result.dataPin.push({
              ...data,
              activityType: "1",
              activityMe: {
                status:
                  data.announcement_type === "1" &&
                  data.permission_main_quotar === data.permission_main_active
                    ? "-2"
                    : "-1",
              },
            });
          } else {
            result.dataUnpin.push({
              ...data,
              activityType: "1",
              activityMe: {
                status:
                  data.announcement_type === "1" &&
                  data.permission_main_quotar === data.permission_main_active
                    ? "-2"
                    : "-1",
              },
            });
          }
          return result;
        },
        {
          dataPin: [],
          dataUnpin: [],
        },
      );
      const activityFormReduce = resArr[1].data.docs.reduce(
        (result, data) => {
          if (data.is_pin) {
            result.dataPin.push({
              ...data,
              activityType: "2",
              activityMe: {
                status:
                  data.announcement_type === "1" &&
                  data.permission_main_quotar === data.permission_main_active
                    ? "-2"
                    : "-1",
              },
            });
          } else {
            result.dataUnpin.push({
              ...data,
              activityType: "2",
              activityMe: {
                status:
                  data.announcement_type === "1" &&
                  data.permission_main_quotar === data.permission_main_active
                    ? "-2"
                    : "-1",
              },
            });
          }
          return result;
        },
        {
          dataPin: [],
          dataUnpin: [],
        },
      );
      _setData(
        [
          ...activityFormReduce.dataPin,
          ...activityReduce.dataPin,
          ...[
            ...activityFormReduce.dataUnpin,
            ...activityReduce.dataUnpin,
            ...resArr[2].data.docs.map((e) => ({ ...e, activityType: "3" })),
          ].sort((a, b) => a.created_at - b.created_at),
        ].slice(0, 6),
      );
    }
  };

  const _handleClickDiscoverMore = () => {
    navigate(ROUTE_PATH.ACTIVITIES);
  };

  const _handleClickActivities = (e) => {
    switch (e.activityType) {
      case "1":
        navigate(`${ROUTE_PATH.ACTIVITIES}/${e._id}`);
        break;
      case "2":
        navigate(`${ROUTE_PATH.ACTIVITY_FORM}/${e._id}`);
        break;
      case "3":
        navigate(`${ROUTE_PATH.NEW}/${e._id}`);
        break;
      default:
        break;
    }
  };

  return !_data ? (
    <></>
  ) : (
    <ActivityNewsWidgetStyled>
      <div className="activity_news_header">
        <div className="activity_news_text">ACTIVITY NEWS</div>
        <div className="liner" />
      </div>
      <div className="activity_news_list">
        {_data &&
          _data.map((e, i) => (
            <div
              className="activity_news_item"
              key={i}
              onClick={() => _handleClickActivities(e)}
            >
              <Cards.ActivityNewsItem
                src={e.activityType === "3" ? e.front_img : e.img}
                title={
                  e.activityType === "3"
                    ? e.title
                    : i18n.language === "en"
                      ? e.short_title_en
                      : e.short_title_th
                }
                subtitle={
                  e.activityType === "3"
                    ? e.description
                    : i18n.language === "en"
                      ? e.short_description_en
                      : e.short_description_th
                }
              />
            </div>
          ))}
      </div>
      <div className="discover_more_button_wrap">
        <Buttons.DiscoverMore onClick={_handleClickDiscoverMore} />
      </div>
    </ActivityNewsWidgetStyled>
  );
};

export default ActivityNewsWidget;
